import { JSX } from 'react';

export enum ESettingsTypes {
  Site = 'site',
  Registration = 'registration',
  Advanced = 'advanced',
  Courses = 'courses',
  Leaderboard = 'leaderboard',
  Integrations = 'integrations',
  Content_Security = 'content_security',
}

export enum ESettingsTypesLabels {
  Site = 'General',
  Registration = 'Registration',
  Advanced = 'Advanced',
  Courses = 'Courses',
  Leaderboard = 'Leaderboard',
  Integrations = 'Integrations',
  Content_Security = 'Content Security',
}

export enum ESettingsAdvancedWidgetLabels {
  COOKIE_BANNER = 'Cookie banner',
  EMAIL_OPTIN = 'Marketing email opt-in',
  SESSION_METADATA = 'Session metadata',
  PUBLISH_LOCKING = 'Publish locking',
  PRODUCT_ID = 'Product ID (DMA)',
}

export type TSettingsAdvancedWidget = {
  label: string;
  content?: JSX.Element;
};

export interface ISiteDetailMetadata {
  name: string;
  description: string;
}

export interface ICalendarDetailMetadata {
  name: string;
  description: string;
}
